import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./api/art";
// import eruda from "eruda";
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$EventBus = new Vue();
import { numberToCurrencyNo } from "@/untils/numberToCurrecy";
Vue.filter("numberToCurrency", numberToCurrencyNo);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// let el = document.createElement("div");
// document.body.appendChild(el);
// eruda.init({
//   container: el,
//   useShadowDom: true,
// });

// if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
//   document.write(
//     unescape(
//       "%3Cspan id='cnzz_stat_icon_1279720885'%3E%3C/span%3E%3Cscript src='https://s9.cnzz.com/z_stat.php%3Fid%3D1279720885' type='text/javascript'%3E%3C/script%3E"
//     )
//   );
// } else {
//   document.write(
//     unescape(
//       "%3Cspan id='cnzz_stat_icon_1279720891'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1279720891' type='text/javascript'%3E%3C/script%3E"
//     )
//   );
// }
